export default __webpack_public_path__ + "static/media/img-0485-andorra-full-face.a9297249.png";